<template>
  <div class="business">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="3"></menuBox>
      <div class="banner-text">
        <div class="title">Layanan bisnis</div>
      </div>
    </div>
    <div class="speed-box">
      <div class="title">Berenanglah di lautan Internet dan temukan peluang Anda berikutnya</div>
      <div class="l-tit">
        Di situs resmi kami, kami berkomitmen untuk menyediakan layanan belanja dan perdagangan Internet yang
        komprehensif dan nyaman bagi Anda. Platform kami menghubungkan pedagang dan konsumen di seluruh dunia melalui
        teknologi canggih dan tim profesional, menyediakan berbagai layanan belanja seperti tampilan produk, pembayaran
        pesanan, dan distribusi logistik. Apakah Anda pengguna perorangan atau pengguna bisnis, Anda dapat menemukan
        produk dan layanan yang memuaskan di sini.
      </div>
      <div class="list">
        <div class="item"><img src="../assets/speed-1.png" alt="">
          <div>
            <h4>Pengalaman berbelanja satu atap</h4>
            <p>Jelajahi inventaris kami yang luas, mulai dari fesyen hingga perabot rumah tangga, elektronik hingga
              hidangan gourmet, toko serba ada untuk semua kebutuhan belanja Anda.</p>
          </div>
        </div>
        <div class="item"><img src="../assets/speed-2.png" alt="">
          <div>
            <h4>Seleksi global, jaminan kualitas</h4>
            <p>Kami mengumpulkan produk berkualitas tinggi dari seluruh dunia dan menjalani penyaringan dan pemeriksaan
              kualitas yang ketat untuk menyajikan kepada Anda produk dengan kualitas terbaik, menjadikan berbelanja
              sebagai pilihan yang dapat dipercaya.</p>
          </div>
        </div>
        <div class="item"><img src="../assets/speed-3.png" alt="">
          <div>
            <h4>Logistik yang sangat cepat, pengiriman mudah</h4>
            <p>Kami memiliki sistem logistik yang efisien untuk memastikan barang Anda terkirim dalam waktu singkat,
              memungkinkan Anda menikmati pengalaman berbelanja yang santai dan menyenangkan.</p>
          </div>
        </div>
        <div class="item"><img src="../assets/speed-4.png" alt="">
          <div>
            <h4>Rekomendasi yang dipersonalisasi, layanan penuh perhatian</h4>
            <p>Berdasarkan riwayat belanja dan preferensi Anda, kami memberikan rekomendasi produk yang dipersonalisasi,
              membuat setiap kunjungan penuh kejutan.</p>
          </div>
        </div>
        <div class="item"><img src="../assets/speed-5.png" alt="">
          <div>
            <h4>Rekomendasi yang dipersonalisasi, layanan penuh perhatian</h4>
            <p>Berdasarkan riwayat belanja dan preferensi Anda, kami memberikan rekomendasi produk yang dipersonalisasi,
              membuat setiap kunjungan penuh kejutan</p>
          </div>
        </div>
        <div class="item"><img src="../assets/speed-6.png" alt="">
          <div>
            <h4>Layanan yang disesuaikan untuk memenuhi kebutuhan khusus</h4>
            <p>Jika Anda memiliki kebutuhan belanja khusus atau menginginkan barang dagangan yang disesuaikan, kami
              menyediakan layanan penyesuaian yang dipersonalisasi untuk memenuhi selera unik Anda.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="share-box">
      <div class="title">Mulailah perjalanan pasar global Anda dengan satu klik dan akses peluang bisnis global dengan mudah.</div>
      <div class="l-tit">
        Platform kami bukan hanya situs belanja online sederhana, namun platform e-commerce komprehensif yang mengintegrasikan belanja dan perdagangan. Di sini, Anda dapat menikmati layanan terpadu mulai dari browsing hingga pembayaran, mulai dari pemesanan hingga penerimaan barang. Baik itu pakaian fesyen, peralatan rumah tangga, atau perdagangan internasional, kami dapat menyediakan produk dan layanan dengan kualitas terbaik untuk Anda. Tujuan kami adalah menggunakan teknologi Internet untuk mengurangi biaya transaksi, meningkatkan kemampuan produksi dan operasi serta efisiensi alokasi sumber daya, memfasilitasi kehidupan masyarakat, dan meningkatkan konsumsi, sirkulasi, dan perdagangan. Memilih kami berarti memilih pengalaman berbelanja yang nyaman, efisien, dan hemat uang!
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {
      aboutUs() {
        this.$router.push({ path: "aboutUs" });
      },
      submit() {
        alert("Success");
      },
    },
  };
</script>
<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-3.png);
    height: 620px;
    background-size: 100% 100%;

    .banner-text {
      margin: 0 360px;
      padding-top: 100px;
      text-align: left;
      margin-top: 100px;

      .title {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 80px;
        color: #333333;
      }

      .text {
        font-size: 26px;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .speed-box {
    padding: 100px 360px;

    .title {
      font-family: HelveticaNeue, HelveticaNeue;
      font-weight: bold;
      font-size: 48px;
      color: #333333;
    }

    .l-tit {
      font-family: HelveticaNeue;
      font-size: 20px;
      color: #333333;
      margin-top: 40px;
    }

    .list {
      margin-top: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .item:nth-child(odd) {
        margin-right: 40px;
      }

      .item {
        background: #EDF1FB;
        width: 560px;
        height: 200px;
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 65px;
          height: 65px;
          margin-left: 31px;
          float: left;
        }

        h4 {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          width: 400px;
        }

        p {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          margin-top: 17px;
          max-width: 380px;
        }
      }
    }
  }

  .share-box {
    background: url(../assets/share.png) 100% no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 480px;
    overflow: hidden;
    text-align: center;

    .title {
      font-family: HelveticaNeue, HelveticaNeue;
      font-weight: bold;
      font-size: 48px;
      color: #333333;
      
      margin: 0 360px;
      margin-top: 100px;
    }

    .l-tit {
      font-family: HelveticaNeue;
      font-size: 24px;
      color: #333333;
      
      margin: 0 180px;
      margin-top: 40px;
    }
  }
</style>